import type { RL, RP } from '@/api';
import type { TenantNotice } from './model';

import { RParam } from '@/api';
import LzdAjax from '@/utils/lzd-ajax';

/** 基础地址 */
const BASE_URL = '/bsl/tenant/notice';

/**
 * 分页查询公告
 */
export async function managerPage(params: RP) {
  params = params ?? {};
  params.where = params.where ?? [];
  return LzdAjax.post<RL<TenantNotice>>(
    `${BASE_URL}/manager/query/page`,
    params
  ).then((v) => v.data);
}

/**
 * 分页查询未读公告
 */
export async function pageTenantNotices(params: RP) {
  params = params ?? {};
  params.where = params.where ?? [];
  return LzdAjax.post<RL<TenantNotice>>(`${BASE_URL}/query/page`, params).then(
    (v) => v.data
  );
}

/**
 * 查询未读公告数量
 */
export async function queryCount(params: RP) {
  params = params ?? {};
  params.where = params.where ?? [];
  return LzdAjax.post<number>(`${BASE_URL}/query/count`, params).then(
    (v) => v.data
  );
}

/**
 * 查询单个公告
 */
export async function queryTenantNoticeSingle(params: RP) {
  params = params ?? {};
  params.where = params.where ?? [];
  return LzdAjax.post<TenantNotice>(`${BASE_URL}/query/single`, params);
}

/**
 * 添加公告
 */
export async function insertTenantNotice(data: Partial<TenantNotice>) {
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/insert`, {
    ...data,
    seq: void 0
  });
}

/**
 * 批量修改公告
 */
export async function updateTenantNotices(params: RP) {
  if (!params.update?.length) {
    return Promise.reject(new Error('没有修改的数据'));
  }
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/update`, params);
}

/**
 * 修改公告
 */
export async function updateTenantNotice(data: Partial<TenantNotice>) {
  if (!data.seq) {
    return Promise.reject(new Error('SEQ不能为空'));
  }
  const rp: RP = {
    update: RParam.buildEdit(data, (k: string) => k != 'id'),
    where: [RParam.eq('id', data.id), RParam.eq('seq', data.seq)]
  };
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/update`, rp);
}

/**
 * 批量删除公告
 */
export async function removeTenantNotices(pks: number[]) {
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/delete`, {
    pks,
    where: []
  });
}

/**
 * 已读消息
 */
export async function readMsg(pks: number[]) {
  if (!pks) {
    return;
  }
  return LzdAjax.post<unknown>(
    `${BASE_URL}/update/read`,
    {
      pks,
      where: []
    },
    false,
    true
  ).then((v) => v.data);
}

/**
 * 登录页分页查询公开通知公告
 * @param tenantId 租户ID
 */
export async function listPublicNotices(tenantId: string) {
  const params = {
    tenantId: tenantId
  };

  return LzdAjax.post<TenantNotice[]>(`${BASE_URL}/public/list`, params).then(
    (v) => v.data
  );
}

class tenantNoticeApi {
  static readMsg = readMsg;
  static queryCount = queryCount;
  static pageTenantNotices = pageTenantNotices;
  static listPublicNotices = listPublicNotices;
}
export default tenantNoticeApi;
